<template>
  <div>
    <fusioncharts v-if="showChart"
      :type="type"
      :width="width"
      :max-height="height"
      dataformat="json"
      :dataSource="dataSource">
      </fusioncharts>
  </div>
</template>

<script>

export default {
  name: 'BarChart',
  props: ['data'],
  data () {
    return {
      showChart: false,
      type: 'bar2d',
      renderAt: 'chart-container',
      width: '100%',
      height: '350',
      dataSource: {
        chart: {
          caption: 'Countries With Most Oil Reserves [2017-18]',
          subcaption: 'In MMbbl = One Million barrels',
          xaxisname: 'Country',
          yaxisname: 'Reserves (MMbbl)',
          numbersuffix: 'K',
          theme: 'fusion'
        },
        data: [
          {
            label: 'Bakersfield Central',
            value: '880000'
          },
          {
            label: 'Garden Groove harbour',
            value: '730000'
          },
          {
            label: 'Los Angeles Topanga',
            value: '590000'
          },
          {
            label: 'Compton-Rancho Dom',
            value: '520000'
          },
          {
            label: 'Daly City Serramonte',
            value: '330000'
          }
        ]
      }
    }
  },
  mounted () {
    if (this.data) {
      this.type = this.data.type
      this.width = this.data.width
      this.height = this.data.height
      this.dataSource = this.data.dataSource
    }
    this.showChart = true
  }
}
</script>
